/**
 * RPC payload construction utilities
 */

import type { RpcPayload } from '../types.js';

function getIfNone<T>(obj: T | null | undefined, defaultValue: T): T {
  return obj !== null && obj !== undefined ? obj : defaultValue;
}

export function getRpcPayload(
  method: string | null,
  params: any[] | null = null,
  id: string | number | null = null,
  jsonrpc: string | number | null = null
): RpcPayload | null {
  if (method === null) {
    return null;
  }

  const rpcParams = getIfNone(params, []);
  const rpcId = parseInt(String(getIfNone(id, 1)), 10);
  const rpcJsonrpc = String(getIfNone(jsonrpc, "2.0"));

  return {
    jsonrpc: rpcJsonrpc,
    id: rpcId,
    method: method,
    params: rpcParams
  };
}
